export enum RecallStatus {
  scheduled = 'Scheduled',
  completed = 'Completed',
  unsaved = 'Unsaved',
  pending = '-',
}
